import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { primaryTint, primaryTintBorder } from "../../surfaceTints";

/** The card, header and spacing shared by the two Desktop App pages. */
export default function DesktopAppPageFrame({
    title,
    subtitle,
    maxWidth = "md",
    // A shorter header, for pages whose content needs the height
    compact = false,
    children,
}) {
    return (
        <Box
            component="main"
            sx={{
                minHeight: "calc(100vh - 64px)",
                backgroundColor: "background.default",
                pt: { xs: 2, sm: 3, md: 4 },
                pb: { xs: 2, sm: 4 },
            }}
        >
            <Container maxWidth={maxWidth} sx={{ px: { xs: 1.5, sm: 3 } }}>
                <Card
                    variant="outlined"
                    sx={{
                        overflow: "hidden",
                        borderRadius: 3,
                        borderColor: "divider",
                        backgroundColor: "background.paper",
                        boxShadow: (theme) =>
                            theme.palette.mode === "dark"
                                ? "0 8px 28px rgba(0, 0, 0, 0.3)"
                                : "0 8px 28px rgba(20, 35, 25, 0.075)",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: compact ? 1.5 : 1.75,
                            p: compact
                                ? { xs: 2, sm: 2.5 }
                                : { xs: 2.5, sm: 3.5 },
                        }}
                    >
                        <Box
                            sx={{
                                width: compact ? 40 : 48,
                                height: compact ? 40 : 48,
                                borderRadius: 2.5,
                                display: "grid",
                                placeItems: "center",
                                flexShrink: 0,
                                color: "primary.main",
                                backgroundColor: primaryTint,
                                border: "1px solid",
                                borderColor: primaryTintBorder,
                            }}
                        >
                            <DesktopMacOutlinedIcon />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography
                                variant="h4"
                                component="h1"
                                sx={{
                                    fontSize: compact
                                        ? { xs: 24, sm: 26 }
                                        : { xs: 27, sm: 32 },
                                    lineHeight: 1.15,
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    mt: compact ? 0.25 : 0.5,
                                    color: "text.secondary",
                                }}
                            >
                                {subtitle}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider />

                    {children}
                </Card>
            </Container>
        </Box>
    );
}
